import React from 'react';

export const LoanIcon = () => (
  <svg width="26px" height="28px" viewBox="0 0 26 28" version="1.1">
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g transform="translate(-1112.000000, -383.000000)" strokeWidth="1.5">
        <g transform="translate(1080.000000, 360.000000)">
          <g transform="translate(19.000000, 12.000000)">
            <g>
              <g transform="translate(14.125000, 11.870690)">
                <path
                  d="M18.8438252,20.1757153 L18.8438252,25.1075569 C18.8438252,25.788151 16.7339449,26.3405172 14.1325548,26.3405172 C11.5308507,26.3405172 9.42191259,25.788151 9.42191259,25.1075569 L9.42191259,20.1757153"
                  stroke="#F5C400"
                />
                <path
                  d="M18.8438252,20.1757153 C18.8438252,20.7944373 16.7339449,21.2965884 14.1325548,21.2965884 C11.5308507,21.2965884 9.42191259,20.7944373 9.42191259,20.1757153 C9.42191259,19.5567132 11.5308507,19.0548423 14.1325548,19.0548423 C16.7339449,19.0548423 18.8438252,19.5567132 18.8438252,20.1757153 Z"
                  stroke="#F5C400"
                />
                <path
                  d="M18.8438252,22.6416327 C18.8438252,23.2603546 16.7339449,23.7625058 14.1325548,23.7625058 C11.5308507,23.7625058 9.42191259,23.2603546 9.42191259,22.6416327"
                  stroke="#F5C400"
                />
                <path
                  d="M23.8318966,16.8130961 C23.8318966,17.431818 21.7220163,17.9339692 19.1206262,17.9339692 C16.5189221,17.9339692 14.409984,17.431818 14.409984,16.8130961 L14.409984,14.57135"
                  stroke="#F5C400"
                />
                <path
                  d="M23.8318966,14.57135 C23.8318966,15.1900719 21.7220163,15.692223 19.1206262,15.692223 C16.5189221,15.692223 14.409984,15.1900719 14.409984,14.57135 C14.409984,13.9523478 16.5189221,13.4504769 19.1206262,13.4504769 C21.7220163,13.4504769 23.8318966,13.9523478 23.8318966,14.57135 Z"
                  stroke="#F5C400"
                />
                <path
                  d="M23.8318966,14.57135 L23.8318966,19.5031915 C23.8318966,20.0987114 22.1620473,20.6211783 19.9522855,20.7361519"
                  stroke="#F5C400"
                />
                <path
                  d="M23.8318966,17.3735326 L23.8318966,22.3053742 C23.8318966,22.900894 22.1620473,23.423361 19.9522855,23.5383346"
                  stroke="#F5C400"
                />
                <path
                  d="M10.2781982,2.24174615 L17.9875396,2.24174615 C18.4586352,2.24174615 18.8438252,2.61948037 18.8438252,3.08240095 C18.8438252,6.96507804 18.8438252,9.31664932 18.8438252,11.2579879 M7.04781707,25.7800807 C5.35718844,25.7800807 4.03231815,25.7800807 0.856285585,25.7800807 C0.386298416,25.7800807 0,25.4012256 0,24.9394259 L0,3.08240095 C0,2.61948037 0.386298416,2.24174615 0.856285585,2.24174615 L3.17019647,2.24174615"
                  stroke="#FFFFFF"
                />
                <polygon
                  stroke="#FFFFFF"
                  points="9.42191259 10.0878577 6.37364675 7.06150037 3.32538091 10.0878577 3.32538091 0 9.42191259 0"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
